import { Component, ViewChild } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ETLDataFeedObj } from '../cxone-etl-data-feed.model';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import { AvailbleBSPositions } from 'ngx-bootstrap/positioning';

@Component({
    selector: 'data-feed-actions-cell-renderer',
    templateUrl: './data-feed-actions-cell-renderer.component.html',
    styleUrls: [
        './data-feed-actions-cell-renderer.component.scss'
    ]
})
export class DataFeedActionsCellRendererComponent implements ICellRendererAngularComp {
    @ViewChild('actionPopover') actionPopover: PopoverDirective;
    public params: ICellRendererParams;
    public dataFeed: ETLDataFeedObj;
    public placement = 'left' as AvailbleBSPositions;
    public showEditBtn = true;
    public showViewBtn = true;
    public showReactivateBtn = true;
    public showDeleteBtn = true;
    public showPreviewBtn = false;
    public canEditLocked = false;

    refresh(params: ICellRendererParams): boolean {
        this.params = params;
        return true;
    }
    agInit(params: ICellRendererParams): void {
        this.params = params;
        this.dataFeed = this.params.data;
        this.placement = this.params.node.rowIndex === this.params.api.getDisplayedRowCount() - 1 ?
            'top left' : 'left';
        this.showEditBtn = params.context.showEditBtn;
        this.showViewBtn = params.context.showViewBtn;
        this.showReactivateBtn = params.context.showReactivateBtn;
        this.showDeleteBtn = params.context.showDeleteBtn;
        this.showPreviewBtn = params.context.showPreviewBtn;
        this.canEditLocked = params.context.canEditLocked;
    }

    onAction(action: string, popover?: NgbPopover): void {
        this.params.context.onRowAction(action, this.params, popover);
    }

    deleteDataFeed(): void {
        this.params.context.deleteDataFeed();
    }

    closePopover(): void {
        this.actionPopover.hide();
    }
}
